<template>
    <section class="px-3 lg:px-28 py-16 lg:py-24">
        <div class="max-w-6xl mx-auto">
            <div class="text-center mb-12 lg:mb-16">
                <h2 class="font-semibold">{{ title }}</h2>
                <p v-if="subtitle" class="max-w-3xl mx-auto mt-4 text-lg text-[color:var(--medium-gray)] leading-relaxed">{{ subtitle }}</p>
            </div>

            <div class="grid gap-6 sm:grid-cols-2" :class="features.length % 3 === 0 ? 'lg:grid-cols-3' : 'lg:grid-cols-2'">
                <div v-for="feature of features" :key="feature.title"
                    class="feature-card flex flex-col rounded-xl border p-6 lg:p-8 transition-colors duration-200 sm:last:odd:col-span-2 lg:last:odd:col-span-1">
                    <div v-if="feature.icon"
                        class="mb-6 flex h-11 w-11 items-center justify-center rounded-lg border bg-[var(--surface-raised)] text-[var(--secondary-blue)]">
                        <Icon :name="feature.icon" class="text-2xl" aria-hidden="true" />
                    </div>
                    <h3 class="box-title mb-3">{{ feature.title }}</h3>
                    <p class="box-description">{{ feature.body }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import { type PropType } from 'vue';

export interface IFeature {
    title: string;
    body: string;
    icon?: string;
}

export default {
    props: {
        title: { type: String, required: true },
        subtitle: String,
        features: { type: Array as PropType<IFeature[]>, required: true },
    },
};
</script>

<style scoped>
.feature-card {
    background: linear-gradient(180deg, var(--surface-raised) 0%, var(--background) 100%);
}

.feature-card:hover {
    border-color: rgb(82, 83, 92);
}
</style>
